import { render, staticRenderFns } from "./AddEventDocument.vue?vue&type=template&id=aa4b7a6e"
import script from "./AddEventDocument.vue?vue&type=script&lang=js"
export * from "./AddEventDocument.vue?vue&type=script&lang=js"
import style0 from "./AddEventDocument.vue?vue&type=style&index=0&id=aa4b7a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports